import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/main/Home.vue";
import About from "../views/main/About.vue";
import ContactUs from "../views/main/ContactUs.vue";
import Blog from "../views/main/Blog.vue";
import DetailBlog from "../views/blog/DetailBlog.vue";
import Event from "../views/event/Event.vue";
import EventDetail from "../views/event/EventDetail.vue";
import EventSuccess from "../views/event/Success.vue";
import Prakerja from "../views/prakerja/Prakerja.vue";
import DetailClassPrakerja from "../views/prakerja/DetailClass.vue";

import KampusMerdeka from "../views/main/KampusMerdeka.vue";
// import TechnologyClass from '../views/public-training/TechnologyClass.vue'
// import LanguageClass from '../views/public-training/LanguageClass.vue'
// import SoftSkillClass from '../views/public-training/SoftSkillClass.vue'
// import DetailClass from '../views/public-training/DetailClass.vue'
import DetailClassBootcamp from '../views/public-training/DetailClassBootcamp.vue'
// import Bootcamp from "../views/bootcamp/Bootcamp.vue"
import Checkout from '../views/transaction/Checkout.vue'
import CheckoutBootcamp from '../views/transaction/CheckoutBootcamp.vue'
import CheckoutEvent from '../views/transaction/CheckoutEvent.vue'
import Login from '../views/auth/Login.vue'
import VerifiedUser from '../views/auth/VerifiedUser.vue'
import CorpotateForm from '../views/corporate/RegistrasionForm.vue'
import SuccessMessage from '../views/success-page/SuccessMessage.vue'
import SuccessMessagePublic from '../views/success-page/SuccessMessagePublic.vue'
import SuccessRequestSyllabus from '../views/success-page/SuccessRequestSyllabus.vue'
import SuccessTransaction from '../views/success-page/SuccessTransaction.vue'
import SuccessCoporateRegistration from '../views/success-page/SuccessCorporateRegistration.vue'
import PageNotFound from '../views/PageNotFound.vue'
// import PublicBootcamp from '../views/public-bootcamp/PublicBootcamp.vue'
import PrivacyPolicy from '../views/other/PrivacyPolicy.vue'
import TermCondition from '../views/other/TermCondition.vue'
// import PublicTraining from '../views/public-training/PublicTraining.vue'
import Testimony from '../views/testimony/Testimony.vue'
import AlumniStories from '../views/alumni-stories/AlumniStories.vue'
import AlumniStoriesDetail from '../views/alumni-stories/Detail.vue'
import Portfolio from '../views/portfolio/Portfolio.vue'
import PortfolioDetail from '../views/portfolio/Detail.vue'

import MainTemplate from '../templates/MainTemplate.vue'
import BlogTemplate from '../templates/BlogTemplate.vue'
import CorporateTemplate from '../templates/CorporateTemplate.vue'

// import Corporate from '../views/corporate/Corporate.vue'
import CheckoutAcceleration from '../views/transaction/CheckoutAcceleration.vue'
import DetailClassAcceleration from '../views/corporate/DetailClassAcceleration.vue'
import CorporateTraining from "../views/corporate/CorporateTraining.vue";
// import AccelerationProgram from '../views/corporate/AccelerationProgram.vue'
import CorporateCollaboration from "../views/corporate/CorporateCollaboration.vue";
import TechService from '../views/corporate/TechService.vue'
// import TalentAsService from '../views/corporate/TalentAsService.vue'
import CorporateSuccess from '../views/corporate/Success.vue'
import FaqTemplate from '@/templates/FaqTemplate.vue';
import FAQ from "@/views/faq/FAQ.vue";

import Career from "../views/career/Career.vue";
import CareerDetail from "../views/career/Detail.vue";
import CareerApplicant from "../views/career/Applicant.vue";
import CareerSuccess from "../views/career/Success.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: MainTemplate,
    meta: {},
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
          title: 'HiColleagues | Ciptakan Masa Depan menjadi Digital Talent Profesional',
          description: 'Lembaga Pelatihan Bootcamp Programming, IT Certification, Webinar seputar teknologi, dan Konsultan IT'
        }
      },
      // {
      //   path: "/class/public-training",
      //   name: "PublicTraining",
      //   component: PublicTraining,
      //   meta: {
      //     title: 'Bootcamp, Training & Outsourcing',
      //     description: 'Belajar dan beli kelas coding, bahasa, softskill, coding bootcamp hanya di HiColleagues. HiColleagues menjadi solusi dan membantu banyak perusahaan sebagai...'
      //   }
      // },
      // {
      //   path: "/class/public-training/:category",
      //   name: "PublicTraining",
      //   component: PublicTraining,
      //   meta: {
      //     title: 'Bootcamp, Training & Outsourcing',
      //     description: 'Belajar dan beli kelas coding, bahasa, softskill, coding bootcamp hanya di HiColleagues. HiColleagues menjadi solusi dan membantu banyak perusahaan sebagai...'
      //   }
      // },
      {
        path: "/class/bootcamp/:slug_name",
        name: "DetailClassBootcamp",
        component: DetailClassBootcamp,
      },
      {
        path: "/contact-us",
        name: "ContactUs",
        component: ContactUs,
        meta: {
          title: 'HiColleagues | Hubungi Kami',
          description: 'Tim HiColleagues siap melayani kebutuhan Akselerasi Digital dalam karir/bisnis dan menjawab pertanyaan Anda. Hubungi kami melalui:'
        }
      },
      {
        path: "/about",
        name: "About",
        component: About,
        meta: {
          title: 'HiColleagues | Empowering Global Talent & Education',
          description: 'HiColleagues adalah platform yang berfokus pada pemberdayaan talenta global melalui pendidikan, pelatihan, dan layanan kolaboratif lintas negara. Kenali visi, misi, dan nilai yang kami bawa dalam setiap inisiatif kami.'
        }
      },
      {
        path: "/event",
        name: "Event",
        component: Event,
      },
      {
        path: "/event/detail/:id",
        name: "EventDetail",
        component: EventDetail,
      },
      {
        path: "/event/success",
        name: "EventSuccess",
        component: EventSuccess,
      },
      {
        path: "/prakerja",
        name: "Prakerja",
        component: Prakerja,
        // meta: {
        //   title: 'Kelas Prakerja',
        //   description: 'Kembangkan kompetensi kerja & kewirausahaan dengan ikut Kelas Prakerja HiColleagues...'
        // }
      },
      {
        path: "/kampusmerdeka",
        name: "KampusMerdeka",
        component: KampusMerdeka
      },
      {
        path: "/portfolio",
        name: "Portfolio",
        component: Portfolio,
        meta: {
          title: 'HiColleagues | Portfolio HiColleagues',
          description: 'Berbagai proyek kemitraan dalam transformasi digital berkelanjutan yang telah berhasil HiColleagues selenggarakan'
        }
      },
      // {
      //   path: "/portfolio/:category",
      //   name: "Portfolio",
      //   component: Portfolio
      // },
      {
        path: "/portfolio/detail/:id",
        name: "PortfolioDetail",
        component: PortfolioDetail
      },
      {
        path: "/alumni-stories",
        name: "AlumniStories",
        component: AlumniStories,
        meta: {
          title: 'HiColleagues | Cerita Alumni',
          description: 'Berbagai cerita alumni program pelatihan akselerasi digital Upskilling, New Skilling, & Reskilling bersama HiColleagues'
        }
      },
      {
        path: "/alumni-stories/:id",
        name: "AlumniStoriesDetail",
        component: AlumniStoriesDetail
      },
      {
        path: "/testimony",
        name: "Testimony",
        component: Testimony,
        meta: {
          title: 'HiColleagues | Testimoni',
          description: 'Testimoni Alumni Kami'
        }
      },
      {
        path: "/faq",
        name: "FAQ",
        component: FAQ,
      },
      // {
      //   path: "/class/public-training/detail/:slugname",
      //   name: "DetailClassPublic",
      //   component: DetailClass,
      // },
      {
        path: "/class/prakerja/:slugname",
        name: "DetailClassPrakerja",
        component: DetailClassPrakerja,
      },
      {
        path: "/checkout",
        name: "Checkout",
        component: Checkout,
      },
      {
        path: "/checkout/bootcamp",
        name: "CheckoutBootcamp",
        component: CheckoutBootcamp,
      },
      {
        path: '/checkout/event/:id',
        name: 'CheckoutEvent',
        component: CheckoutEvent
      },
      {
        path: "/account/verify/:token",
        name: "VerifiedUser",
        component: VerifiedUser,
      },
      {
        path: "/success-request-syllabus",
        name: "SuccessRequestSyllabus",
        component: SuccessRequestSyllabus,
      },
      {
        path: "/success-transaction",
        name: "SuccessTransaction",
        component: SuccessTransaction,
      },
      {
        path: "/success-public",
        name: "SuccessMessagePublic",
        component: SuccessMessagePublic,
      },
      {
        path: "/success",
        name: "SuccessMessage",
        component: SuccessMessage,
      },
      {
        path: "/registration/success",
        name: "SuccessCoporateRegistration",
        component: SuccessCoporateRegistration,
      },
      {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: PrivacyPolicy,
      },
      {
        path: "/term-condition",
        name: "TermCondition",
        component: TermCondition,
      },
      {
        path: "/career",
        name: "Career",
        component: Career,
      },
      {
        path: "/career/:id",
        name: "CareerDetail",
        component: CareerDetail,
      },
      {
        path: "/career/applicant/:id",
        name: "CareerApplicant",
        component: CareerApplicant,
      },
      {
        path: "/career-success",
        name: "CareerSuccess",
        component: CareerSuccess,
      },
      {
        path: '/certification/detail/:slug_name',
        name: 'DetailClassCertification',
        component: DetailClassAcceleration
      },
      {
        path: '/certification/checkout',
        name: 'CheckoutCertification',
        component: CheckoutAcceleration
      },
    ],
  },

  {
    path: "/corporate",
    component: CorporateTemplate,
    children: [
      {
        path: "form",
        name: "CorporateForm",
        component: CorpotateForm,
      },
      {
        path: "collaboration",
        name: "Collaboration",
        component: CorporateCollaboration,
        meta: {
          title: 'HiColleagues | Kolaborasi Korporat dan Membuka Peluang Global',
          description: 'HiColleagues mengajak perusahaan dan institusi untuk berkolaborasi dalam menghadirkan program pendidikan internasional, beasiswa luar negeri, dan pengembangan talenta global.'
        }
      },
      // {
      //   path: "talent-service",
      //   name: "TalentService",
      //   component: TalentAsService,
      //   meta: {
      //     title: 'HiColleagues | Talent Service for Companies',
      //     description: 'Temukan dan kembangkan talenta terbaik bersama HiColleagues. Layanan talent sourcing, assessment, dan development yang dirancang untuk memenuhi kebutuhan perusahaan Anda.'
      //   }
      // },
      {
        path: "it-staffing",
        name: "Services",
        component: TechService,
        meta: {
          title: 'HiColleagues | IT Resourcing, IT Outsourcing, IT Headhunting',
          description: 'HiColleagues menyediakan layanan menyeluruh untuk pengembangan talenta di perusahaan, mulai dari pelatihan, konsultasi SDM, hingga solusi manajemen organisasi yang disesuaikan dengan kebutuhan Anda.'
        }
      },

      {
        path: "training",
        name: "Training",
        component: CorporateTraining,
        meta: {
          title: 'HiColleagues | Pelatihan Karyawan',
          description: 'Tingkatkan performa tim Anda dengan program pelatihan korporat dari HiColleagues. Materi disesuaikan untuk kebutuhan bisnis Anda agar hasilnya nyata dan berkelanjutan.'
        }
      },
      {
        path: "success",
        name: "Success",
        component: CorporateSuccess,
      }
    ],
  },
  {
    path: "/blog",
    component: BlogTemplate,
    children: [
      {
        path: "",
        name: "Blog",
        component: Blog,
        meta: {
          title: 'HiColleagues | Artikel',
          description: 'Tambah wawasanmu dengan artikel-artikel yang terbaru dan kece...'
        }
      },
      {
        path: ":slugname",
        name: "DetailBlog",
        component: DetailBlog,
      },
    ],
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/blog/mobile/:slugname",
    name: "DetailMobileBlog",
    component: DetailBlog,
  },
  {
    path: "/privacy-policy/mobile",
    name: "PrivacyPolicyMobile",
    component: PrivacyPolicy,
  },
  {
    path: "/term-condition/mobile",
    name: "TermConditionMobile",
    component: TermCondition,
  },
  {
    path: "/berita",
    component: FaqTemplate,
    children: []
  },
  { path: "*", component: PageNotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const metaDescription = to.meta.description || "Coding Bootcamp";
  const metaTag = document.querySelector('meta[name="description"]');
  if (metaTag) {
    metaTag.setAttribute('content', metaDescription);
  }
  next();
});

export default router;
